import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import IPhoneService from "./pages/IPhoneService";
import IPhoneScreenReplacement from "./pages/IPhoneScreenReplacement";
import IPhoneBatteryReplacement from "./pages/IPhoneBatteryReplacement";
import MacBookService from "./pages/MacBookService";
import IPadService from "./pages/IPadService";
import WatchService from "./pages/WatchService";
import ServiceAreas from "./pages/ServiceAreas";
import Franchise from "./pages/Franchise";
import Updates from "./pages/Updates";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import IPhone16CommonProblems from "./pages/blog/IPhone16CommonProblems";
import AirPodsMicrophoneSetupGuide from "./pages/blog/AirPodsMicrophoneSetupGuide";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/iphone-service" element={<IPhoneService />} />
          <Route path="/iphone-service/screen-replacement" element={<IPhoneScreenReplacement />} />
          <Route path="/iphone-service/battery-replacement" element={<IPhoneBatteryReplacement />} />
          <Route path="/macbook-service" element={<MacBookService />} />
          <Route path="/ipad-service" element={<IPadService />} />
          <Route path="/watch-service" element={<WatchService />} />
          <Route path="/service-areas" element={<ServiceAreas />} />
          <Route path="/franchise" element={<Franchise />} />
          <Route path="/updates" element={<Updates />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/iphone-16-common-problems-fix-patna" element={<IPhone16CommonProblems />} />
          <Route path="/blog/airpods-microphone-setup-guide-2026" element={<AirPodsMicrophoneSetupGuide />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
